module.exports = __webpack_public_path__ + "static/media/ArboreumLogoLight.da9c5890.svg";